import React, { createRef } from 'react';
import { Form } from 'react-bootstrap';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { connect } from 'react-redux';
import { submitForApproval } from '../core/store/actions/auth'; // Import the new action
import "../styles/Form.css";
import { withRouter } from 'react-router-dom';
import "../styles/responsive.css";

import { Icon } from '@iconify/react/dist/iconify.js';

class RegisterPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      imagePreviewUrl: '',
    };
    this.fileInputRef = createRef();
  }
  fileInputRef = createRef();
  handleFileChange = (event) => {
    const reader = new FileReader();
    const file = event.target.files[0];

    reader.onloadend = () => {
      this.setState({
        imagePreviewUrl: reader.result,
      });
    };

    reader.readAsDataURL(file);
  };
  render() {
    const { imagePreviewUrl } = this.state;

    //console.log(email);

    const withIcon = (message) => (
      <span style={{ display:'flex', alignItems:'center', textAlign:'center'}}>
        <Icon icon="f7:exclamationmark-circle-fill" style={{marginRight:'5px', marginLeft:'24px'}}/> {message}
      </span>
    );

    return (
      <div className="container-info">
        <div className="title mb-3">Tell us more about you</div>
        <div >
          <Formik
            initialValues={{
              // Add new fields for submitting user information for approval
              fullName: '',
              nickname: '',
              birthday: '',
              email: '',
              institutionalEmail: '',
              phoneNumber: '',
              address: '',
              nationality: '',
              naturality: '',
              professionalStatus: '',
              emergencyContactName: '',
              emergencyContactRelationship: '',
              emergencyContactPhone: '',
              mobilityIn: '',
              mobilityProgram: '',
              joinedIn: '',
              esnAccountUsername: '',
              profilePicture: Yup.mixed().test(
                'fileSize',
                withIcon('File size is too large'),
                (value) => !value || (value && value.size <= 10485760) // 10 MB limit
              ),
            }}
            validationSchema={Yup.object().shape({
              // Add validation for the new fields
              fullName: Yup.string().required(withIcon('Full name is required')),
              nickname: Yup.string(),
              birthday: Yup.date().required(withIcon('Birthday is required')),
              email: Yup.string().email(withIcon('Must be a valid email')).required(withIcon('Email is required')),
              institutionalEmail: Yup.string().email(),
              phoneNumber: Yup.string(),
              address: Yup.string(),
              nationality: Yup.string().required(withIcon('Nationality is required')),
              naturality: Yup.string(),
              professionalStatus: Yup.string(),
              emergencyContactName: Yup.string(),
              emergencyContactRelationship: Yup.string(),
              emergencyContactPhone: Yup.string(),
              mobilityIn: Yup.string(),
              mobilityProgram: Yup.string(),
              joinedIn: Yup.string(),
              esnAccountUsername: Yup.string(),
              // ... other validations ...
            })}
            onSubmit={(values, { setSubmitting }) => {
              // Call the new action to submit user information for approval
              values.username = this.props.username
              this.props.submitForApproval(values)
                .then(() => {
                  // Redirect to the next page or show a success message if needed
                  this.props.history.push('/success'); // Replace with your desired route
                })
                .catch((error) => {
                  // Handle errors, e.g., show an error message
                  console.error('Submission for approval failed:', error);
                })
                .finally(() => {
                  setSubmitting(false);
                });
            }}
          >
            {({ values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting }) => (
              <Form onSubmit={handleSubmit} >
                <div className="enter-info-layout">
                  {/* First Column */}
                  <div className="info-column">
                    <div className="form-group-title">My Details</div>

                    <Form.Group controlId="formFullName" className="form-group">
                      <label htmlFor="fullName">Full Name</label>
                      <input
                        className={`info-input ${touched.fullName && errors.fullName ? 'is-invalid' : ''}`}
                        type="text"
                        name="fullName"
                        placeholder="Full Name"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.fullName}
                      />
                      {touched.fullName && errors.fullName && <div className="invalid-feedback">{errors.fullName}</div>}
                    </Form.Group>
                    <div className="row">
                      <div className="col-md-6">
                        <Form.Group controlId="formNickname" className="form-group">
                          <label htmlFor="nickname">Nickname</label>
                          <input
                            className={`info-input-mini`}
                            type="text"
                            name="nickname"
                            placeholder="Nickname"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.nickname}
                          />

                        </Form.Group>

                        <Form.Group controlId="formBirthdate" className="form-group">
                          <label htmlFor="birthdate">Date of Birth</label>
                          <input
                            className={`info-input-mini ${touched.birthdate && errors.birthdate ? 'is-invalid' : ''}`}
                            type="date"
                            name="birthdate"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.birthdate}
                          />
                          {touched.birthdate && errors.birthdate && <div className="invalid-feedback">{errors.birthdate}</div>}
                        </Form.Group>
                      </div>
                      <div className="col-md-6">
                        <Form.Group controlId="formProfilePicture" className="form-group">
                          <Form.Label>Profile Picture</Form.Label>
                          <input
                            type="file"
                            name="profilePicture"
                            ref={this.fileInputRef} // Set the ref for the file input
                            onBlur={handleBlur}
                            accept="image/*"
                            onChange={this.handleFileChange} // Add this line

                          />
                            {imagePreviewUrl && <img src={imagePreviewUrl} alt="Profile Preview" className="image-preview" />}

                        </Form.Group>
                      </div>
                    </div>

                    <Form.Group controlId="formEmail" className="form-group">
                      <label htmlFor="email">
                        Email
                      </label>
                      <input
                        className={`info-input ${touched.email && errors.email ? 'is-invalid' : ''}`}
                        type="email"
                        name="email"
                        placeholder="Email"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.email}
                      />
                      {touched.email && errors.email && <div className="invalid-feedback">{errors.email}</div>}
                    </Form.Group>

                    <Form.Group controlId="formInstitutionalEmail" className="form-group">
                      <label htmlFor="institutionalEmail">
                        Institutional Email
                      </label>
                      <input
                        className={`info-input ${touched.institutionalEmail && errors.institutionalEmail ? 'is-invalid' : ''}`}
                        type="email"
                        name="institutionalEmail"
                        placeholder="Institutional Email"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.institutionalEmail}
                      />
                      {touched.institutionalEmail && errors.institutionalEmail && <div className="invalid-feedback">{errors.institutionalEmail}</div>}
                    </Form.Group>

                    <div className="row">
                      <div className="col-md-6">
                        <Form.Group controlId="formPhoneNumber" className="form-group">
                          <label htmlFor="phoneNumber">Phone Number</label>
                          <input
                            className={`info-input-mini ${touched.phoneNumber && errors.phoneNumber ? 'is-invalid' : ''}`}
                            type="tel"
                            name="phoneNumber"
                            placeholder="Phone Number"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.phoneNumber}
                          />
                          {touched.phoneNumber && errors.phoneNumber && <div className="invalid-feedback">{errors.phoneNumber}</div>}
                        </Form.Group>


                        <Form.Group controlId="formAddress" className="form-group">
                          <label htmlFor="address">Address</label>
                          <input
                            className={`info-input-mini ${touched.address && errors.address ? 'is-invalid' : ''}`}
                            type="text"
                            name="address"
                            placeholder="Address"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.address}
                          />
                          {touched.address && errors.address && <div className="invalid-feedback">{errors.address}</div>}
                        </Form.Group>
                      </div>

                      {/* Second Column */}
                      <div className="col-md-6">
                        <div className="row">
                          <div className="col-md-12">
                            <Form.Group controlId="formNationality" className="form-group">
                              <label htmlFor="nationality">Nationality</label>
                              <input
                                className={`info-input-mini ${touched.nationality && errors.nationality ? 'is-invalid' : ''}`}
                                type="text"
                                name="nationality"
                                placeholder="Nationality"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.nationality}
                              />
                              {touched.nationality && errors.nationality && <div className="invalid-feedback">{errors.nationality}</div>}
                            </Form.Group>
                            <Form.Group controlId="formNaturality" className="form-group">
                              <label htmlFor="naturality">Naturality</label>
                              <input
                                className={`info-input-mini ${touched.naturality && errors.naturality ? 'is-invalid' : ''}`}
                                type="text"
                                name="naturality"
                                placeholder="Naturality"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.naturality}
                              />
                              {touched.naturality && errors.naturality && <div className="invalid-feedback">{errors.naturality}</div>}
                            </Form.Group>

                          </div>
                        </div>
                      </div>

                      <Form.Group controlId="formProfessionalStatus" className="form-group">
                        <label htmlFor="professionalStatus">Professional Status</label>
                        <input
                          className={`info-input ${touched.professionalStatus && errors.professionalStatus ? 'is-invalid' : ''}`}
                          type="text"
                          name="professionalStatus"
                          placeholder="Professional Status"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.professionalStatus}
                        />
                        {touched.professionalStatus && errors.professionalStatus && (
                          <div className="invalid-feedback">{errors.professionalStatus}</div>
                        )}
                      </Form.Group>



                    </div>




                  </div>

                  {/* Second Column */}
                  <div className="info-column">
                    <div className="form-group-title">Emergency Contact</div>

                    <Form.Group controlId="formEmergencyContactName" className="form-group">
                      <label htmlFor="emergencyContactName">Name</label>
                      <input
                        className={`info-input ${touched.emergencyContactName && errors.emergencyContactName ? 'is-invalid' : ''}`}
                        type="text"
                        name="emergencyContactName"
                        placeholder="Name"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.emergencyContactName}
                      />
                      {touched.emergencyContactName && errors.emergencyContactName && <div className="invalid-feedback">{errors.emergencyContactName}</div>}
                    </Form.Group>

                    <Form.Group controlId="formEmergencyContactRelationship" className="form-group">
                      <label htmlFor="emergencyContactRelationship">Relationship</label>
                      <input
                        className={`info-input`}
                        type="text"
                        name="emergencyContactRelationship"
                        placeholder="Relationship"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.emergencyContactRelationship}
                      />
                    </Form.Group>

                    <Form.Group controlId="formEmergencyContactPhone" className="form-group">
                      <label htmlFor="emergencyContactPhone">Phone Number</label>
                      <input
                        className={`info-input ${touched.emergencyContactPhone && errors.emergencyContactPhone ? 'is-invalid' : ''}`}
                        type="tel"
                        name="emergencyContactPhone"
                        placeholder="Phone Number"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.emergencyContactPhone}
                      />
                      {touched.emergencyContactPhone && errors.emergencyContactPhone && (
                        <div className="invalid-feedback">{errors.emergencyContactPhone}</div>
                      )}
                    </Form.Group>


                    <div className="form-group-title">My Mobility and ESN</div>

                    <Form.Group controlId="formMobilityIn" className="form-group">
                      <label htmlFor="mobilityIn">I did my mobility in</label>
                      <input
                        className={`info-input`}
                        type="text"
                        name="mobilityIn"
                        placeholder="Mobility In"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.mobilityIn}
                      />
                    </Form.Group>

                    <Form.Group controlId="formMobilityProgram" className="form-group">
                      <label htmlFor="mobilityProgram">Mobility Program</label>
                      <input
                        className={`info-input ${touched.mobilityProgram && errors.mobilityProgram ? 'is-invalid' : ''}`}
                        type="text"
                        name="mobilityProgram"
                        placeholder="Mobility Program"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.mobilityProgram}
                      />
                      {touched.mobilityProgram && errors.mobilityProgram && (
                        <div className="invalid-feedback">{errors.mobilityProgram}</div>
                      )}
                    </Form.Group>

                    <Form.Group controlId="formJoinedIn" className="form-group">
                      <label htmlFor="joinedIn">Date I Joined ESN</label>
                      <input
                        className={`info-input ${touched.joinedIn && errors.joinedIn ? 'is-invalid' : ''}`}
                        type="date"
                        name="joinedIn"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.joinedIn}
                      />
                      {touched.joinedIn && errors.joinedIn && (
                        <div className="invalid-feedback">{errors.joinedIn}</div>
                      )}
                    </Form.Group>

                  </div>

                </div>

                <div className="submit-button-box">
                  <button className="submit-button button" disabled={isSubmitting} type="submit">
                    Submit
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({ user: state.user });

// Connect the new action to the component
export default connect(mapStateToProps, { submitForApproval })(withRouter(RegisterPage));
